import { Point } from '@colonist/game-mechanic-validators';
import { ViewAnimationController } from '../ViewAnimationController.ts';
import { UIGameGoToPointAnimation } from './UIGameGoToPointAnimation.ts';
export class ViewAnimationControllerAdapter extends ViewAnimationController {
    set animationCompleteCallBack(value) {
        this.animation.setOnStopCallback(value);
    }
    /** @deprecated If you see this, refactor the animation to use GoToPointAnimation instead` */ animateTo(destination, speed) {
        var _this_animation;
        (_this_animation = this.animation) === null || _this_animation === void 0 ? void 0 : _this_animation.setSpeed(speed !== null && speed !== void 0 ? speed : 1).setDestination(destination).start();
    }
    constructor(view){
        super(view);
        this.animation = new UIGameGoToPointAnimation(view, new Point(0, 0), 0);
    }
}
